<template>
  <div id="search-input" :style="divStyle">
    <div class="input-container">
      <input
        type="text"
        v-if="showInput"
        :style="inputStyle"
        v-model="search"
        :placeholder="$t('search')"
        @focus="loadList()"
        @blur="saveFreeText"
        @keyup.enter.prevent="saveFreeText"
        :disabled="disabled"
      />
      <span v-if="search && !disabled" class="clear-btn" @click="clearSelection">×</span>
    </div>
    <div id="list">
      <ul>
        <li v-for="(value, index) in list" :key="index" @click="selectItem(value)">
          {{ renderLabel(value) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'search-input',
  props: [
    'inputStyle',
    'url',
    'divStyle',
    'field',
    'field2',
    'source',
    'searchField',
    'listdata',
    'extraParams',
    'allowFreeText',
    'disabled',
    'format'
  ],
  created () {
    this.debouncedGetAnswer = _.debounce(this.loadList, 500)
  },
  mounted () {
    this.initializeSearch()
    this.loadList()
  },
  watch: {
    data () {
      this.emitData()
    },
    search () {
      this.debouncedGetAnswer()
    },
    source (newVal) {
      if (newVal !== this.data) {
        this.data = newVal
        this.updateSearch()
      }
    }
  },
  data () {
    return {
      data: {},
      search: '',
      showInput: true,
      list: []
    }
  },
  methods: {
    ...mapActions({
      getList: 'listes/list'
    }),
    initializeSearch () {
      if (this.source && (this.resolve(this.source, this.field) || this.source.name)) {
        this.data = this.source
        this.updateSearch()
      }
    },
    emitData () {
      this.$emit('data', this.data)
      this.updateSearch()
    },
    updateSearch () {
      this.search = this.renderLabel(this.data)
    },
    renderLabel (item) {
      if (!item || (typeof item === 'object' && Object.keys(item).length === 0)) {
        return ''
      }

      if (this.format) {
        return this.format.replace(/{(\w+)}/g, (match, key) => {
          return this.resolve(item, key) || ''
        })
      }

      let label = this.resolve(item, this.field) || item.name || ''
      if (this.field2) {
        const res2 = this.resolve(item, this.field2)
        if (res2) {
          label += ' - ' + res2
        }
      }
      return label
    },
    loadList () {
      this.getList({ path: this.url, filters: Object.assign({ [this.searchField || this.field]: this.search }, this.extraParams) })
        .then((response) => {
          if (this.listdata && this.listdata.length > 0) {
            this.list = response.filter(x => {
              return this.listdata.some(data => data === x.id)
            })
          } else {
            this.list = response
          }
        })
    },
    selectItem (value) {
      this.data = value
      this.search = this.renderLabel(this.data)
    },
    clearSelection () {
      this.data = null
      this.search = ''
      this.emitData()
      this.loadList()
    },
    saveFreeText () {
      // if free text is not allowed, do nothing
      if (!this.allowFreeText) return

      const text = (this.search || '').trim()

      // if the text is empty, do nothing
      if (!text) return

      // if the text is the same as current value, do nothing
      const current = this.resolve(this.data, this.field) || this.data.name || ''
      if (text === (current || '').trim()) return

      // set the data with the free text
      this.data = { [this.field]: text }
      this.emitData()
    },
    resolve (o, s) {
      if (typeof o !== 'object' || o === null) {
        return
      }

      s = s.replace(/\[(\w+)\]/g, '.$1')
      s = s.replace(/^\./, '')
      var a = s.split('.')

      for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i]
        if (k in o) {
          o = o[k]
        } else {
          return
        }
      }
      return o
    }
  }
}
</script>

<style scoped lang="scss">
#search-input {
  position: relative;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.clear-btn {
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #999;
  font-weight: bold;
  font-size: 1.2em;
  line-height: 1;
  user-select: none;

  &:hover {
    color: #666;
  }
}

input {
  width: 100%;
  padding-right: 25px !important; /* Space for the clear button */
}

input:focus + .clear-btn + #list,
.input-container:focus-within + #list,
#list:hover {
  visibility: visible;
  opacity: 1;
}

#list {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.2s, opacity 0.2s ease-out;
  position: absolute;
  width: 100%;
  border: 2px solid #CCCCCC;
  border-bottom-left-radius: .6em;
  border-bottom-right-radius: .6em;
  overflow: auto;
  max-height: 10em;
  background: white;
  box-sizing: border-box;
  z-index: 99999;
}

ul {
  margin: .2em;
  list-style: none;
  background: white;
  color: #088aab;
}

li {
  padding: .1em .5em;
  border-radius: .4em;
  transition: all 0.1s;
  cursor: pointer;

  &:hover {
    background: rgb(181, 238, 255);
  }
}</style>



// WEBPACK FOOTER //
// src/components/SearchSelect.vue